import React, { useState } from 'react'
import { withRouter } from 'react-router'
import WithUser from 'hocs/WithUser'
import DashboardNavbar from './DashboardNavbar'
import DashboardSidebar from './DashboardSidebar'
import { RouteTitle } from '../PageTitle'
// import Footer from 'components/Footer'
import { Drawer } from 'antd'

const DashboardLayout = ({ children }) => {
  const [showDrawer, setShowDrawer] = useState(false)

  return (
    <div className="dashboard">
      {/*
        The browser tab, for every page inside this layout — including ones written after this
        line. A page that wants something more specific renders its own; react-helmet takes the
        last-mounted title, and a page mounts inside the layout, so a page's own always wins.
      */}
      <RouteTitle />
      <div className="dashboard_nav">
        <div className="dashboard_nav_side">
          <DashboardSidebar />
        </div>

        <div className="dashboard_nav_top">
          <DashboardNavbar handleOpen={() => setShowDrawer(true)} />
        </div>
      </div>

      <div className="dashboard_page">
        {children}
        {/* <Footer className="mt-5rem" /> */}
      </div>
      <Drawer
        title="Menu"
        placement={'left'}
        onClose={() => setShowDrawer(false)}
        open={showDrawer}
        className="navbar_drawer"
      >
        <DashboardSidebar />
      </Drawer>
    </div>
  )
}

export default withRouter(WithUser(DashboardLayout))
